<div class="container-fluid p-3 bg-amber-50">

  <div class="bg-white rounded-md  border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
    <div class="flex gap-3">
    
      <div class="flex-1">
        <h4 class="text-xl sm:text-2xl font-bold text-slate-800 mb-1">
          {{stepDetails?.name}}
        </h4>
    
        <h5 class="text-base sm:text-lg text-blue-600 font-semibold mb-3">
          [{{ proposalName }}]
        </h5>
    
    
      </div>
      <div>
        
        <span class="inline-flex items-center px-3 py-1.5 border-2 rounded-full text-sm font-bold transition-all" [ngClass]="{
                        'bg-slate-100 text-slate-700 border border-slate-500': stepDetails?.step_status == 0,
                        'bg-emerald-100 text-emerald-700 border border-emerald-500': stepDetails?.step_status == 'approved',
                        'bg-amber-100 text-amber-700 border border-amber-500': stepDetails?.step_status == 'recommended',
                        'bg-blue-100 text-blue-700 border border-blue-500': stepDetails?.step_status == 'initiated'
                      }">
          <span class="w-2 h-2 rounded-full mr-2 animate-pulse" [ngClass]="{
                          'bg-slate-500': stepDetails?.step_status == 0,
                          'bg-emerald-500': stepDetails?.step_status == 'approved',
                          'bg-amber-500': stepDetails?.step_status == 'recommended',
                          'bg-blue-500': stepDetails?.step_status == 'initiated'
                        }"></span>
          {{ stepDetails?.step_status == 0 ? " PENDING" : (stepDetails?.step_status | uppercase) }}
        </span>
      </div>
    </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap items-center gap-2">
       
        <ng-container *ngIf="stepDetails?.can_edit">
          <button (click)="routeConfig.emit({isRouteConfig: true})"  class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />

  <!-- Parsed WBS Table -->
<div class="bg-white rounded-md  border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
  <h6 class="text-base sm:text-lg font-bold text-slate-800 mb-3">Milestones & Tranche Payments</h6>
  <p-table [value]="milestones" dataKey="id" [paginator]="true" [rows]="10">
    <ng-template pTemplate="header">
      <tr>
        <th>Milestone</th>
        <th>Deliverable</th>
        <th>Sub-Deliverable</th>
        <th>Tranche</th>
        <th>% Payment</th>
        <th>Start Date</th>
        <th>End Date</th>
        <th>Status</th>
        <th>Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-m let-i="rowIndex">
      <tr>
        <!-- Milestone Title -->
        <td>
          <ng-container *ngIf="!m.isEditMode; else editMode">
            {{ m.title }}
          </ng-container>
          <ng-template #editMode>
            <input type="text" pInputText [(ngModel)]="m.title" class="form-control form-control-sm" />
          </ng-template>
        </td>
        
        <!-- Deliverable -->
        <td>
          <ng-container *ngIf="!m.isEditMode; else editDeliverable">
            {{ m.deliverable }}
          </ng-container>
          <ng-template #editDeliverable>
            <input type="text" pInputText [(ngModel)]="m.deliverable" class="form-control form-control-sm" />
          </ng-template>
        </td>

        <!-- Sub-Deliverable -->
        <td>
          <ng-container *ngIf="!m.isEditMode; else editSubDeliverable">
            {{ m.sub_deliverable }}
          </ng-container>
          <ng-template #editSubDeliverable>
            <input type="text" pInputText [(ngModel)]="m.sub_deliverable" class="form-control form-control-sm" />
          </ng-template>
        </td>

        <!-- Tranche -->
        <td>
          <ng-container *ngIf="!m.isEditMode; else editTranche">
            {{ m.tranche || '-' }}
          </ng-container>
          <ng-template #editTranche>
            <input type="text" pInputText [(ngModel)]="m.tranche" class="form-control form-control-sm" />
          </ng-template>
        </td>

        <!-- % Payment -->
        <td>
          <ng-container *ngIf="!m.isEditMode; else editPercentage">
            {{ m.percentage }}%
          </ng-container>
          <ng-template #editPercentage>
            <input type="number" pInputText [(ngModel)]="m.percentage" class="form-control form-control-sm" placeholder="%" />
          </ng-template>
        </td>

        <!-- Start Date -->
        <td>
          <ng-container *ngIf="!m.isEditMode; else editStartDate">
            {{ m.start_date | date }}
          </ng-container>
          <ng-template #editStartDate>
            <input type="date" class="form-control form-control-sm" [(ngModel)]="m.start_date" />
          </ng-template>
        </td>

        <!-- End Date -->
        <td>
          <ng-container *ngIf="!m.isEditMode; else editEndDate">
            {{ m.end_date | date }}
          </ng-container>
          <ng-template #editEndDate>
            <input type="date" class="form-control form-control-sm" [(ngModel)]="m.end_date" />
          </ng-template>
        </td>

        <!-- Status -->
        <td>
          <ng-container>
            <span class="badge" [ngClass]="{
              'bg-success': m.status === 'Completed',
              'bg-warning': m.status === 'Ongoing',
              'bg-danger': m.status === 'Delayed',
              'bg-secondary': !m.status
            }">
              {{ m.status || 'Pending' }}
            </span>
          </ng-container>
          <!-- <ng-template #editStatus>
            <select class="form-control form-control-sm" [(ngModel)]="m.status">
              <option value="Completed">Completed</option>
              <option value="Ongoing">Ongoing</option>
              <option value="Delayed">Delayed</option>
              <option value="Pending">Pending</option>
            </select>
          </ng-template> -->
        </td>

        <!-- Actions -->
        <td>
          <div class="d-flex gap-3">
            <button *ngIf="!m.isEditMode" class="btn btn-sm btn-primary me-1" (click)="m.isEditMode = true">Edit</button>
            <button *ngIf="m.isEditMode" class="btn btn-sm btn-success me-1" (click)="saveMilestone(m)">Save</button>
            <button *ngIf="m.isEditMode" class="btn btn-sm btn-secondary" (click)="m.isEditMode = false">Cancel</button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>


</div>